export const bank = [
    { id: '002', name: 'ธนาคารกรุงเทพ' },
    { id: '004', name: 'ธนาคารกสิกรไทย' },
    { id: '006', name: 'ธนาคารกรุงไทย' },
    { id: '011', name: 'ธนาคารทหารไทย' },
    { id: '014', name: 'ธนาคารไทยพาณิชย์' },
    { id: '025', name: 'ธนาคารกรุงศรีอยุธยา' },
    // { id: '069', name: 'ธนาคารเกียรตินาคิน' },
    // { id: '022', name: 'ธนาคารซีไอเอ็มบีไทย' },
    // { id: '067', name: 'ธนาคารทิสโก้' },
    { id: '065', name: 'ธนาคารธนชาต' },
    { id: '024', name: 'ธนาคารยูโอบี' },
    // { id: '020', name: 'ธนาคารสแตนดาร์ดชาร์เตอร์ด (ไทย)' },
    { id: '030', name: 'ธนาคารออมสิน' },
    { id: '033', name: 'ธนาคารอาคารสงเคราะห์' },
    // { id: '066', name: 'ธนาคารอิสลามแห่งประเทศไทย' },
]


// WEBPACK FOOTER //
// ./src/constant/Bank.js